import { MiTHEME } from "@miplatform/theme";

export const workDependencyMapColors = [
  {
    backgroundColor: MiTHEME.palette.primary.light,
    color: MiTHEME.palette.primary.main,
  },
  {
    backgroundColor: MiTHEME.palette.orange.light,
    color: MiTHEME.palette.vibrant.orange_10,
  },
  {
    backgroundColor: MiTHEME.palette.deepPurple.light,
    color: MiTHEME.palette.deepPurple.medium,
  },
  {
    backgroundColor: MiTHEME.palette.pink.light,
    color: MiTHEME.palette.pink.main,
  },
  {
    backgroundColor: MiTHEME.palette.blue.light,
    color: MiTHEME.palette.blue.secondary,
  },
  {
    backgroundColor: MiTHEME.palette.common.white,
    color: MiTHEME.palette.green.secondary,
  },
  {
    backgroundColor: MiTHEME.palette.grey.light,
    color: MiTHEME.palette.grey.darkAccent,
  },
];
